export const aiEngineeringCurriculumMessages = [
  {
    message:
      'Here is the curriculum of the Fellowship Program in AI Engineering that Crio is offering.',
    sentTime: new Date().toISOString(),
    sender: 'bot',
    direction: 'incoming',
    position: 'first',
    type: 'text',
  },
  {
    message:
      'This is a build-first program for software engineers: 6 months of live sessions, plus a live 2-week Interview Preparation Sprint, followed by recorded sessions. You will ship 16+ AI applications and learn to take AI systems from problem framing to production.',
    sentTime: new Date().toISOString(),
    sender: 'bot',
    direction: 'incoming',
    position: 'normal',
    type: 'text',
  },
  {
    message: 'AI Engineering Fellowship Curriculum',
    sentTime: new Date().toISOString(),
    sender: 'bot',
    direction: 'incoming',
    position: 'normal',
    type: 'section',
    payload: [
      {
        title: 'Sprint 1: AI Engineering Foundations',
        content:
          'Understand how production AI applications differ from traditional software, learn LLM building blocks, prompt and context engineering, model selection, and evaluation fundamentals. An applied machine learning refresher covers the concepts needed for the rest of the program.',
      },
      {
        title: 'Sprint 2: Retrieval-Augmented Generation (RAG)',
        content:
          'Ground models in real company data using embeddings, vector databases, hybrid search, reranking, citations, conversation memory, and guardrails. Measure retrieval and answer quality with golden sets, RAGAS, and tracing.',
      },
      {
        title: 'Sprint 3: AI Agents and MCP',
        content:
          'Build agents that plan, use tools, and act safely over real systems. Create a multi-tenant MCP server with authentication, RBAC, human approval for writes, guardrails, and agent evaluations, then coordinate specialist agents with frameworks such as LangGraph and CrewAI.',
      },
      {
        title: 'Sprint 4: Evals, Fine-Tuning, and Coding Agents',
        content:
          'Treat evaluations as CI gates using golden datasets and automated regression checks. Fine-tune open models with LoRA and QLoRA, compare cost and quality against base and frontier models, and use coding agents through a spec-to-plan-to-build-to-review workflow.',
      },
      {
        title: 'Sprint 5: Production AI, AWS, and Voice',
        content:
          'Deploy and operate AI systems with observability, latency and cost controls, security, compliance, incident drills, and eval-gated CI/CD. Work with AWS Bedrock, AgentCore or SageMaker, and build a real-time voice agent with streaming ASR, TTS, tool use, and interruption handling.',
      },
      {
        title: 'Sprint 6: Capstone and Large-Codebase Delivery',
        content:
          'Ship a real feature into a large codebase with coding agents, then own an AI product end to end: frame the problem, write the spec and success metrics, build the MVP, deploy it on AWS, evaluate and monitor it, and present it on demo day.',
      },
      {
        title: 'Weeks 25-26: Interview Preparation Sprint',
        content:
          'Prepare for agentic system design, technical, and behavioural rounds with mock interviews and scored feedback. The program targets AI Engineer, Agent Engineer, GenAI or LLM Application Engineer, Applied AI or Solutions Engineer, and Forward Deployed Engineer roles.',
      },
    ],
  },
  {
    message: 'Production Applications You Will Build',
    sentTime: new Date().toISOString(),
    sender: 'bot',
    direction: 'incoming',
    position: 'normal',
    type: 'section',
    payload: [
      {
        title: 'AskDocs',
        content:
          'A production RAG assistant over real workspace documents, with cited answers, hybrid retrieval, reranking, evaluations, tracing, and cost and latency monitoring.',
      },
      {
        title: 'TriageOps',
        content:
          'A multi-agent support operations system that classifies tickets, drafts grounded replies, routes work, and escalates sensitive actions to a human.',
      },
      {
        title: 'DomainCopilot',
        content:
          'A fine-tuned vertical copilot built with LoRA or QLoRA and RAG, measured against base and frontier models on your own golden dataset.',
      },
      {
        title: 'VoiceMate',
        content:
          'A real-time voice agent with streaming speech recognition, speech generation, tool use, barge-in support, and measured latency and cost.',
      },
      {
        title: 'ShipIt',
        content:
          'An earlier AI build productionised on AWS with eval-gated CI/CD, monitoring, cost alarms, an incident fire drill, and a handover runbook.',
      },
      {
        title: 'RepoAgent',
        content:
          'A merge-quality feature shipped into a large open-source codebase using coding agents, backed by an evaluation suite and green CI.',
      },
      {
        title: 'Your Capstone',
        content:
          'Your own deployed AI product, delivered with a one-page spec, success metrics, source code, evaluation report, live demo, and operations dashboard.',
      },
    ],
  },
  {
    message: 'Program Format and Prerequisites',
    sentTime: new Date().toISOString(),
    sender: 'bot',
    direction: 'incoming',
    position: 'last',
    type: 'section',
    payload: [
      {
        title: 'Weekly Commitment',
        content:
          'Plan for about 10 hours per week: approximately 5 hours of live sessions with practising AI engineers and 5 hours of assessed take-home building.',
      },
      {
        title: 'Who It Is For',
        content:
          'The program is built for software engineers who are comfortable writing code and want to move into production AI roles. Python, cloud, and AI foundations are recapped where needed, while the work stays engineering-focused.',
      },
      {
        title: 'Included Lab Stack',
        content:
          'AWS cloud sandbox, LLM API access, vector database, evaluation and observability tooling, voice and deployment resources, and lab kits for all builds are included for the duration of the program.',
      },
    ],
  },
];
